if($('.faqSection').length){
    $('html').on('click', '.faq .h6', function(){
        $(this).closest('.faq').find('.content').slideToggle();
        $(this).closest('.faq').toggleClass('openIt');
    })
}